import { AfterViewInit, Component, Input, OnInit, inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TextFieldModule } from '@angular/cdk/text-field';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IReferralLinkSettings, ReferralLinkSettings } from 'src/app/api/api-campaigns.service.generated';
import { UploadImageService } from 'src/app/common/services/upload-image.service';
import { PhotoComponent } from 'wecheer-common';
import { SpecialCharacterDirective } from 'src/app/common/directives/specialIsAlphaNumeric.directive';

@Component({
  selector: 'app-refferal-link-setting',
  templateUrl: './refferal-link-setting.component.html',
  styleUrls: ['./refferal-link-setting.component.scss'],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FlexLayoutModule,
    TextFieldModule,
    PhotoComponent,
    SpecialCharacterDirective
  ]
})
export class RefferalLinkSettingComponent implements OnInit, AfterViewInit {
  private fb = inject(FormBuilder);
  private snackBar = inject(MatSnackBar);
  private uploadImageService = inject(UploadImageService);


  @Input() enabled: boolean;
  @Input() data: IReferralLinkSettings;

  form: FormGroup;

  photoUrl: string;
  uploadPhotoKey: string;
  maxFileSize = 1 * 1024 * 1024;

  ngAfterViewInit(): void {
    this.enabled = !!this.data;
    this.photoUrl = this.data?.thumbnailUrl;
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      referralTitle: new FormControl(this.data?.title || '', [
        Validators.required,
        Validators.maxLength(60)
      ]),
      referralDescription: new FormControl(this.data?.description || '', [
        Validators.maxLength(300)
      ]),
      referralMessage: new FormControl(this.data?.message || '', [
        Validators.maxLength(512)
      ])
    })
  }

  onEnabledChanged() { }

  async onThumbImageSelected(event) {
    try {
      const file = event.target.files[0];
      const { result, imageUrl, errorMessage } = await this.uploadImageService.uploadImage(this.uploadPhotoKey, file, this.maxFileSize);

      if (!result) {
        this.snackBar.open(errorMessage, 'Dismiss', { duration: 2000 });
      } else {
        this.photoUrl = imageUrl;
      }
    } catch (err) {
      console.error('upload failed', err);
    }
  }

  isValid() {
    if (!this.enabled) {
      return true;
    }

    if (!this.form.valid) {
      this.forceValidatorsToDisplayErrors();
    }

    return this.form.valid && !!this.photoUrl;
  }

  forceValidatorsToDisplayErrors() {
    this.form.markAllAsTouched();
  }

  getFormValue(): ReferralLinkSettings {
    if (!this.isValid() || !this.enabled) {
      return undefined;
    }

    let referralinkSettings: ReferralLinkSettings = new ReferralLinkSettings();
    referralinkSettings.thumbnailUrl = this.photoUrl;
    referralinkSettings.title = this.form?.get('referralTitle').value;
    referralinkSettings.description = this.form?.get('referralDescription').value;
    referralinkSettings.message = this.form?.get('referralMessage').value;
    return referralinkSettings;
  }

}
